import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { createPageUrl } from "../utils/createPageUrl";

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__grid">
          {/* Brand */}
          <div className="footer__brand">
            {/* Nouveau wrapper en ligne */}
            <div className="footer__brand-header">
              <div className="footer__logo">
                <img
                  src="/logo.png"
                  alt="Serve & Code logo"
                  className="footer__logo-img"
                />
              </div>
              <span className="footer__brand-name">Serve &amp; Code</span>
            </div>

            <p className="footer__tagline">
              {t("footer.tagline")}
            </p>
          </div>

          {/* Colonne Services */}
          <div className="footer__column">
            <h3 className="footer__column-title">
              {t("footer.services")}
            </h3>
            <ul className="footer__list">
              <li>
                <Link
                  to={createPageUrl("TennisCoaching")}
                  className="footer__link"
                >
                  {t("nav.tennis")}
                </Link>
              </li>
              <li>
                <Link
                  to={createPageUrl("WebDevelopment")}
                  className="footer__link"
                >
                  {t("nav.webDev")}
                </Link>
              </li>
            </ul>
          </div>

          {/* Colonne Contact */}
          <div className="footer__column">
            <h3 className="footer__column-title">
              {t("footer.contact")}
            </h3>
            <ul className="footer__list footer__list--contact">
              <li>hello@serveandcode.com</li>
            </ul>
          </div>
        </div>

        <div className="footer__bottom">
          <p className="footer__bottom-text">
            © 2024 Serve &amp; Code. {t("footer.rights")}
          </p>
          <div className="footer__bottom-links">
            <a href="#" className="footer__bottom-link">
              {t("footer.privacy")}
            </a>
            <a href="#" className="footer__bottom-link">
              {t("footer.terms")}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
